import { useSurveyFile } from '@tm/client-form/src/hooks/useSurveyFile'
import { ImageField } from '@tm/shared-lib/src/field'
import { InputProps } from '../types'
import { DefaultImageInput } from './DefaultImageInput'
import { ProfileImageInput } from './ProfileImageInput'
import { ImageInputProps } from './types'
import { useFileField } from './useFileField'

export function ImageInput(props: InputProps<ImageField>) {
  const { field, onChange } = props
  const [file, setFile] = useSurveyFile<File>(field)

  const fileTypes = '.jpg,.jpeg,.png,.gif,.svg'

  const fileFieldState = useFileField({
    onChange,
    setFile,
    fileTypes,
  })

  const inputProps: ImageInputProps = {
    parentProps: props,
    fileFieldState,
    file,
    fileTypes,
  }

  // imageFilename is profile picture in reviews
  const isProfile = field.name === 'imageFilename' || field.name === 'companyLogo'

  if (isProfile) return <ProfileImageInput {...inputProps} />
  return <DefaultImageInput {...inputProps} />
}
